import { render, staticRenderFns } from "./BaseCrop.vue?vue&type=template&id=5cb9f5cc"
import script from "./BaseCrop.vue?vue&type=script&lang=js"
export * from "./BaseCrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports